// extracted by mini-css-extract-plugin
module.exports =  {"slotHighlighted":"kvywDN"};